import { getCurrentUserEmail } from '@/components/AuthenticationHandler/selectors'
import { RootState } from '@/store'
import { getOrgAdminRole, getUsers } from '@/store/selectors'
import { mapToUser } from '@/utilities/UserUtilities'

export const mapPaginatedUsers = (state: RootState) => {
  const currentPageUsers = state.organizationUsersPage.page
  if (currentPageUsers) {
    const orgAdminRoleId = getOrgAdminRole(state).id
    const currentUserEmail = getCurrentUserEmail(state)
    const users = getUsers(state)
    return currentPageUsers.map(pageUser => {
      return mapToUser(users.byId[pageUser], currentUserEmail, orgAdminRoleId)
    })
  }
}

export const getFilter = (state: RootState) => {
  return state.organizationUsersPage.filter || ''
}

export const getTotalUsers = (state: RootState) => {
  return state.organizationUsersPage.totalUsers || 0
}

export const getStartIndex = (state: RootState) => {
  return state.organizationUsersPage.startIndex || 1
}

export const getSortingColumn = (state: RootState) => {
  return state.organizationUsersPage.sortingColumn
}

export const getIsEditingUser = (state: RootState) => {
  return state.organizationUsersPage.isEditingUser
}
